<template>
  <div class="productBigImg" v-show="bigImgOnOff">
    <img
      @click="$emit('hideBigImg')"
      :data-srcset="bigImgGallery[index]?bigImgGallery[index].url:''"
      :srcset="bigImgGallery[index]?bigImgGallery[index].url:''"
      data-sizes="auto"
      @error.once="imageFailure"
      class="lazyload"
      alt
    />
    <span class="iconfont cancel" @click="$emit('hideBigImg')">&#xe61a;</span>
    <span
      class="iconfont left_arrow"
      @click.stop="toggleindex(1)"
      v-show="this.bigImgGallery.length>1"
    >&#xe630;</span>
    <span
      class="iconfont right_arrow"
      @click.stop="toggleindex(0)"
      v-show="this.bigImgGallery.length>1"
    >&#xe62f;</span>
  </div>
</template>
<script>
export default {
  props: ["bigImgOnOff", "bigImgGallery", "bigImgGalleryIndex"],
  data() {
    return {
      index: 0
    };
  },
  methods: {
    toggleindex(e) {
      if (e) {
        console.log("--------------");
        this.index--;
        this.index =
          this.index < 0 ? this.bigImgGallery.length - 1 : this.index;
      } else {
        console.log("+++++++++++++");
        this.index++;
        this.index = this.index == this.bigImgGallery.length ? 0 : this.index;
      }
      console.log("index", this.index);
      console.log("this.bigImgGallery.length", this.bigImgGallery.length);
    }
  },
  watch: {
    bigImgGallery() {
      console.log(this.bigImgGallery);
    },
    bigImgGalleryIndex() {
      console.log(this.bigImgGalleryIndex);
      this.index = this.bigImgGalleryIndex;
    }
  }
};
</script>
<style scoped lang='scss'>
.productBigImg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  z-index: 99999;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: zoom-out;
    max-width: 100%;
    max-height: 100%;
    height: auto;
    display: block;
    // animation: zoomIn 0.5s;
    // -webkit-animation: zoomIn 0.5s;
  }
  span {
    cursor: pointer;
    position: absolute;
    font-size: 24px;
    color: #333;
    font-weight: 700;
    padding: 10px;
  }
  .cancel {
    top: 20px;
    right: 20px;
  }
  .left_arrow {
    top: 50%;
    left: 20px;
    font-weight: 400;
  }
  .right_arrow {
    top: 50%;
    right: 20px;
    font-weight: 400;
  }
}
</style>